module.exports = __webpack_public_path__ + "header-logo-dca67f81.png";